import { queryOptions } from '@tanstack/react-query';
import { bannerAPIClient } from '../bannerAPIClient';
import { BANNER_QUERY_KEYS } from './keys';
import type { GetBannersRequest } from './types';

export const BANNER_QUERIES = {
  getBanners: (params: GetBannersRequest) =>
    queryOptions({
      queryKey: BANNER_QUERY_KEYS.getBanners(params),
      queryFn: () => bannerAPIClient.getBanners(params),
    }),
};
